// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2M5p8","question":"Question_question__gkkJh","description":"Question_description__PIHvb"};